import React from 'react';
import cn from 'classnames';

import Card from '../Card';
import Text from '../Text';
import Share from '../Share';

import { externalLink } from '../../util';

import * as styles from './Podcast.module.css';
import * as textStyles from '../../styles/text.module.css';

const Podcast = ({
  headline,
  byLine,
  duration,
  intro,
  spotifyUrl,
  applePodcastsUrl,
  episodeId,
  id,
  slug
}) => {
  const subscribeLinks = [];

  if (applePodcastsUrl) {
    subscribeLinks.push(
      <a key="apple" href={applePodcastsUrl} {...externalLink}>
        Apple Podcasts
      </a>
    );
  }
  if (applePodcastsUrl && spotifyUrl) {
    subscribeLinks.push(' o ');
  }
  if (spotifyUrl) {
    subscribeLinks.push(
      <a key="spotify" href={spotifyUrl} {...externalLink}>
        Spotify
      </a>
    );
  }

  return (
    <Card id={id} className={cn(styles.root)} title="Un podcast" animate>
      <h3 className={cn(textStyles.headline, styles.headline)}>{headline}</h3>
      <div className={cn(styles.podcastInfo)}>
        <div className={cn(styles.podcastByLine)}>
          <p className={styles.name}>Por {byLine.name}</p>
          <p>
            {byLine.role}
            {byLine.role && byLine.company && ', '}
            {byLine.company}
          </p>
        </div>
        <div className={cn(styles.podcastDuration)}>
          <strong>Duración</strong> {duration}&thinsp;min.
        </div>
      </div>
      <Text className={cn(textStyles.body, styles.podcastIntro)} text={intro} />
      <div className={cn(styles.podcastPlayerWrapper)}>
        <iframe
          title="Refracciones Podcast Player"
          src={`https://open.spotify.com/embed/episode/${episodeId}`}
          className={cn(styles.podcastPlayer)}
          frameBorder="0"
          allowFullScreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        />
      </div>

      {(applePodcastsUrl || spotifyUrl) && (
        <p className={cn(styles.subscribe)}>
          Subscríbete al podcast en {subscribeLinks}.
        </p>
      )}
      <Share url={`${slug}#${id}`} className={cn(styles.share)} />
    </Card>
  );
};

export default Podcast;
